import React, { useState } from 'react';

const mockCertificates = [
  {
    id: 1,
    title: 'Technical Interview Preparation Workshop',
    issueDate: '2025-05-15',
    presenter: 'Dr. Ahmed Hassan',
    type: 'Workshop Completion',
    description: 'Successfully completed the technical interview preparation workshop.',
    skills: ['Interview Skills', 'Problem Solving', 'Communication'],
    certificateUrl: '#'
  },
  {
    id: 2,
    title: 'Web Development Assessment',
    issueDate: '2025-05-10',
    type: 'Skill Assessment',
    score: 92,
    description: 'Achieved excellence in web development skills assessment.',
    skills: ['React', 'JavaScript', 'Web Development'],
    certificateUrl: '#'
  }
];

const Certificates = () => {
  const [certificates] = useState(mockCertificates);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const downloadCertificate = (certificate) => {
    // In a real application, this would trigger a download of the certificate PDF
    console.log('Downloading certificate:', certificate.title);
  };

  if (selectedCertificate) {
    return (
      <div className="container">
        <div className="card" style={{ 
          maxWidth: '800px', 
          margin: '2rem auto',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h2 style={{ marginBottom: '1.5rem' }}>{selectedCertificate.title}</h2>
          
          <div style={{ 
            border: '2px solid #2196F3',
            borderRadius: '8px',
            padding: '2rem',
            marginBottom: '2rem'
          }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>
              This certifies that
            </p>
            <h3 style={{ 
              color: '#2196F3',
              margin: '1rem 0',
              fontSize: '1.5rem'
            }}>
              Ahmed Khaled
            </h3>
            <p style={{ marginBottom: '1.5rem' }}>
              {selectedCertificate.description}
            </p>
            
            {selectedCertificate.score && (
              <div style={{ 
                backgroundColor: '#e3f2fd',
                color: '#2196F3',
                padding: '0.5rem 1rem',
                borderRadius: '20px',
                display: 'inline-block',
                marginBottom: '1.5rem'
              }}>
                Score: {selectedCertificate.score}%
              </div>
            )}
            
            <div style={{ marginTop: '1rem' }}>
              <p style={{ fontSize: '0.9rem', color: '#666' }}>
                Issued on {selectedCertificate.issueDate}
              </p>
              {selectedCertificate.presenter && (
                <p style={{ fontSize: '0.9rem', color: '#666' }}>
                  Presenter: {selectedCertificate.presenter}
                </p>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            <button
              className="btn-secondary"
              onClick={() => setSelectedCertificate(null)}
            >
              Back
            </button>
            <button
              className="btn-primary"
              onClick={() => downloadCertificate(selectedCertificate)}
            >
              Download Certificate
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <header style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h1>My Certificates</h1>
        <p>View and download your earned certificates</p>
      </header>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '2rem',
        padding: '1rem'
      }}>
        {certificates.map(certificate => (
          <div
            key={certificate.id}
            className="card"
            style={{ padding: '1.5rem' }}
          >
            <div style={{ 
              display: 'inline-block',
              padding: '0.25rem 0.75rem',
              borderRadius: '15px',
              backgroundColor: '#e3f2fd',
              color: '#2196F3',
              fontSize: '0.875rem',
              marginBottom: '1rem'
            }}>
              {certificate.type}
            </div>
            
            <h3 style={{ marginBottom: '1rem' }}>{certificate.title}</h3>
            <p style={{ 
              color: '#666',
              marginBottom: '1rem',
              fontSize: '0.9rem'
            }}>
              Issued on {certificate.issueDate}
            </p>
            
            {certificate.score && (
              <p style={{ marginBottom: '1rem' }}>
                <strong>Score:</strong> {certificate.score}%
              </p>
            )}
            
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap',
              gap: '0.5rem',
              marginBottom: '1.5rem'
            }}>
              {certificate.skills.map((skill, index) => (
                <span
                  key={index}
                  style={{
                    backgroundColor: '#f5f5f5',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '15px',
                    fontSize: '0.875rem'
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>

            <button
              className="btn-primary"
              onClick={() => setSelectedCertificate(certificate)}
              style={{ width: '100%' }}
            >
              View Certificate
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;
